module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4823748f50030407329768f2674e49a9.gif";